<template>
  <tr class="text-body border-strokes text-grey-1 h-0 border-t border-solid">
    <td class="text-black-2 px-4! py-2! whitespace-nowrap">
      {{ dayjs(props.timestamp, { format: "YYYYDDMMHHmm" }).format("MMM D, YYYY HH:mm:ss") }}
    </td>
    <td v-if="errorTab" class="text-black-2 px-4! py-2!">
      <span class="inline-flex max-w-full" :title="props.connector || '-'">
        <span class="truncate whitespace-nowrap">
          {{ props.connector || "-" }}
        </span>
      </span>
    </td>
    <td class="text-black-2 px-4! py-2! break-words">
      <div class="flex flex-col">
        <span class="break-words">{{ props.activity || props.error || "-" }}</span>
        <span v-if="!fullView && props.variation_name" class="line-clamp-1">
          Variation: {{ props.variation_name }}
        </span>
      </div>
    </td>
    <td v-if="fullView" class="text-black-2 px-4! py-2!">
      <div class="flex flex-col">
        <RouterLink
          class="text-heading-2 line-clamp-1 text-blue-50"
          :to="getPromptLink(props.prompt_id, props.appId)"
        >
          {{ props.prompt_name }}
        </RouterLink>
        <span v-if="props.experiment_name"> Experiment: {{ props.experiment_name }}</span>
        <span v-if="props.variation_name"> Variation: {{ props.variation_name }}</span>
      </div>
    </td>
    <td v-if="survey" class="text-black-2 px-4! py-2! break-words">
      {{ props.survey_option }}
    </td>
    <td>
      <RfTooltip class="ml-0! w-fit">
        <template #activator> <RfHelpIcon class="h-6! w-6!" /> </template>
        <template #tooltip>
          <div class="flex w-64 flex-col">
            <span>
              <span class="font-bold">Device category:</span> {{ props.device_category }}
            </span>
            <span><span class="font-bold">Device type:</span> {{ props.device_type }} </span>
            <span><span class="font-bold">Language:</span> {{ props.language }} </span>
            <span><span class="font-bold">Segment ID:</span> {{ props.segment_id }}</span>
            <span v-if="props.anon_linked_from_user_id"
              ><span class="font-bold">Linked from user:</span>
              {{ props.anon_linked_from_user_id }}</span
            >
            <span v-if="props.anon_user_id"
              ><span class="font-bold">Anon User ID:</span> {{ props.anon_user_id }}</span
            >
          </div>
        </template>
      </RfTooltip>
    </td>
    <td class="text-black-2 px-4! py-2!">
      <button
        class="inline-flex max-w-full items-center gap-2"
        :title="props.user_id"
        @click="copyToClipboard(props.user_id, 'User id copied to the clipboard')"
      >
        <span class="truncate whitespace-nowrap">
          {{ props.user_id }}
        </span>
        <RfCopyIcon class="h-6! w-6! shrink-0" />
      </button>
    </td>
  </tr>
</template>

<script setup>
import { getPromptLink } from "@/utils/getLink";
import dayjs from "dayjs";
import copyToClipboard from "@/utils/CopyToClipboard";
import RfCopyIcon from "@/components/icons/RfCopyIcon.vue";
import RfHelpIcon from "@/components/icons/RfHelpIcon.vue";
import RfTooltip from "@/components/tooltip/RfTooltip.vue";

const props = defineProps({
  fullView: { type: Boolean, default: false },
  timestamp: { type: String, default: dayjs().format("YYYYDDMMHHmm") },
  user_id: { type: String, default: "-" },
  prompt_name: { type: String, default: "-" },
  prompt_id: { type: String, default: "" },
  appId: { type: String, default: "" },
  variation_name: { type: String, default: "" },
  experiment_name: { type: String, default: "" },
  activity: { type: String, default: "" },
  connector: { type: String, default: "" },
  error: { type: String, default: "" },
  errorTab: { type: Boolean, default: false },
  survey: { type: Boolean, default: false },
  survey_option: { type: String, default: "-" },
  device_category: { type: String, default: "-" },
  device_type: { type: String, default: "-" },
  language: { type: String, default: "-" },
  segment_id: { type: String, default: "-" },
  anon_linked_from_user_id: { type: String, default: "" },
  anon_user_id: { type: String, default: "" },
});
</script>
